import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getConfirmData, closeConfirm } from '../redux/app';
import { StyleSheet, css } from 'aphrodite/no-important';
import { FONTS, BASE_SPACING, MEDIA_QUERIES } from '../styles';
import Button, { TYPES } from '../components/Button';
import Text from '../components/Text';
import Popup from '../components/Popup';

const s = StyleSheet.create({
  title: {
    ...FONTS.BOLD,
    fontSize: 22,
    marginBottom: BASE_SPACING * 1.2,
    alignSelf: 'flex-start',
  },
  buttons: {
    paddingTop: BASE_SPACING * 1.5,
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
  },
  customButton: {
    marginLeft: 10,
  },
  button: {
    width: '100%',
    [MEDIA_QUERIES.ON_DESKTOP]: {
      width: 'auto',
    },
  },
});

const Confirm = ({ title, message, cancel, buttons, close, visible }) => {
  if (!visible) {
    return null;
  }
  return (
    <Popup>
      <Text {...title} className={css(s.title)} />
      <Text {...message} className={css(s.text)} />
      <div className={css(s.buttons)}>
        <Button
          messageId={cancel}
          onClick={close}
          __type={TYPES.SECONDARY}
          __className={s.button}
        />
        {(buttons || []).map((button) => (
          <Button
            __type={TYPES.PRIMARY}
            {...button}
            onClick={(e) => !!button.onClick && button.onClick(close, e)}
            __className={[s.customButton, s.button]}
            key={button.messageId}
          />
        ))}
      </div>
    </Popup>
  );
};

Confirm.propTypes = {
  title: PropTypes.object,
  message: PropTypes.object,
  cancel: PropTypes.string,
  buttons: PropTypes.array,
  visible: PropTypes.bool,
  close: PropTypes.func,
};

const mapStateToProps = (state) => ({
  ...getConfirmData(state),
});

const mapDispatchToProps = (dispatch) => ({
  close: () => dispatch(closeConfirm()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Confirm);
